import { useNavigate } from 'react-router-dom';
import { authService, UserRole } from '../api';
import { useApi } from './useApi';
import { useAuth } from './useAuth';
import { getRoleRedirectPath } from '../utils/userUtils';

interface RegisterFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
}

export const useRegister = () => {
  const navigate = useNavigate();
  const { updateAuth } = useAuth();

  const { loading, error, execute } = useApi({
    successMessage: 'Registration successful! Welcome to AutoPlace.',
    showSuccessToast: true,
    showErrorToast: true,
    onSuccess: (response: any) => {
      const token = response?.access_token || response?.token;
      const user = response?.user;

      if (token && user) {
        updateAuth(token, user);
      }

      setTimeout(() => {
        navigate(getRoleRedirectPath(user?.role));
      }, 1000);
    },
  });

  const register = async (formData: RegisterFormData) => {
    return execute(() =>
      authService.register({
        ...formData,
        role: UserRole.PRIVATE,
        deviceType: 'web',
      })
    );
  };

  return {
    register,
    loading,
    error,
  };
};
